/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const LocationPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Location pin"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M14.765 16.998c1.802-2.266 3.36-5.045 3.36-7.725 0-3.012-2.52-5.455-5.625-5.455S6.875 6.261 6.875 9.273c0 2.68 1.558 5.459 3.36 7.725a28 28 0 0 0 2.265 2.505 28 28 0 0 0 2.265-2.505M12.5 22S20 15.864 20 9.273C20 5.257 16.641 2 12.5 2S5 5.257 5 9.273C5 15.863 12.5 22 12.5 22"
        clipRule="evenodd"
      />
      <path
        fill="#0E0E0E"
        d="M14.375 9.273c0 1.004-.84 1.818-1.875 1.818s-1.875-.814-1.875-1.818.84-1.818 1.875-1.818 1.875.814 1.875 1.818"
      />
    </g>
  </svg>
);

export const LocationPinIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'location-pin-icon'}
      icon={LocationPin}
      {...props}
      size={size}
    />
  );
};
